import { useMutation } from 'react-query';

import { axiosWithoutInterceptors } from '@/lib/axios';

type SubscribtionAdditionnalInformationData = {
  weeklyDispatchVolume: string;
  registrationNumber: string;
  paymentMethodId: string;
  companyTypeId: string;
  holderName: string;
  vatNumber: boolean;
  bankName: string;
  kbisFile?: File;
  eori: string;
  iban: string;
  bic: string;
};

type UpdateCrossingRequestedDateType = {
  data: SubscribtionAdditionnalInformationData;
};

const submitSubscribeAdditionnalInformationAsync = ({ data }: UpdateCrossingRequestedDateType) =>
  axiosWithoutInterceptors.post<string>(`/prospects`, data);

export const useSubmitSubscribeAdditionnalInformationAsync = () =>
  useMutation({
    mutationFn: submitSubscribeAdditionnalInformationAsync,
  });
